import { Parse } from 'src/boot/parse'
import languages from 'quasar/lang/index.json'

export function logged (state) {
  return (state.token.length && Parse.User.current() !== null)
}

export const getLangIndex = (state) => (iso) => {
  if (!iso || iso === 'other') return 999
  return state.languages.findIndex(lang => lang === iso)
}

export const getFlagByLang = (state) => (lang) => state.flags[lang]

/**
 * langOptions - langueges used in app. How it has to be after fix
 * @param {object} state - vuex store
 * @returns { Array<{ isoName: string, nativeName: string, flag: string }>}
 */
// Quasar's own `nativeName` is wrong for a couple of packs, and the picker shows it
// verbatim. Override here rather than patching node_modules. The Planner
// (src/i18n/supported-locales.ts) and Admin (src/i18n/supported-locales.js) carry the
// same map — keep the three in sync.
//   lt → Quasar says "Lithuanian" (English, unlike every other entry)
//   hi → Quasar says "अमेरिकी अंग्रेज़ी", which literally means "American English"
const NATIVE_NAME_OVERRIDES = {
  lt: 'Lietuvių',
  hi: 'हिन्दी'
}

const nativeNameFor = (isoName, quasarNativeName) =>
  NATIVE_NAME_OVERRIDES[isoName] ||
  NATIVE_NAME_OVERRIDES[isoName.split('-')[0]] ||
  quasarNativeName

export const langOptions = (state) => {
  // When no plain `base` entry exists in Quasar, prefer these specific variants
  const PREFERRED = { en: 'en-US', zh: 'zh-CN' }

  // Group all Quasar lang entries by base language code
  const byBase = {}
  languages.forEach(lang => {
    const base = lang.isoName.split('-')[0]
    if (!byBase[base]) byBase[base] = []
    byBase[base].push(lang)
  })

  const list = state.languages
    .filter(base => byBase[base])
    .map(base => {
      const entries = byBase[base]
      const lang =
        // 1. Exact base match (e.g. "de", "ar")
        entries.find(l => l.isoName === base)
        // 2. Known preferred variant (e.g. "en-US" over "en-GB")
        || entries.find(l => l.isoName === PREFERRED[base])
        // 3. First available fallback
        || entries[0]
      // Never hand Quasar's raw nativeName to the UI — two of them are wrong.
      return { ...lang, nativeName: nativeNameFor(lang.isoName, lang.nativeName) }
    })
  // "Other" — any language not in the list; server falls back to English (index 999)
  list.push({ isoName: 'other', nativeName: 'Other' })
  return list
}

export function user (state) {
  return state.user
}

export function loading (state) {
  return state.loading
}

export function saving (state) {
  return state.saving
}

export function token (state) {
  return state.token
}

export function verificationCode (state) {
  return state.verificationCode
}

export function location (state) {
  return state.location
}

export function checked (state) {
  return state.checked
}

export function addresses (state) {
  return state.addresses
}
